const copy = {
  messageErrorsPresent: {
    headers: {
      messageStatusHeader: (
        lastNDays: number
      ) => `We've found that there are issues with your message deliverability
      over the past ${lastNDays} days.`,
      viewIssuesBy: "View issues by:",
    },
    callToAction: {
      troubleshoot: "I have a message to troubleshoot",
    },
    messageStatusCopy: (
      failedMessages: number,
      undeliveredMessages: number,
      percentMessagesFailed: string
    ) => {
      return (
        <>
          Your account has <b>{failedMessages}</b> failed messages and{" "}
          <b>{undeliveredMessages}</b> undelivered messages, constituting{" "}
          {percentMessagesFailed} of your total message traffic. Would you like
          to learn more about the root causes?
        </>
      );
    },
  },
  noMessageErrorsPresent: {
    headers: {
      messageStatusHeader: "Great news!",
      viewIssuesBy: "View issues by:",
      sampleQuestions: "Sample questions",
    },
    callToAction: {
      helpMe: "How can you help me?",
      commonMessageErrors: "What are common message errors?",
      deliverabilityScore: "What is Deliverability Score?",
      deliveredVersusFailed: "What are undelivered vs. failed status?",
    },
    messageStatusCopy: (
      lastNDays: number
    ) => `Your account doesn't have messaging deliverability errors in the last 
      ${lastNDays} days.`,
    haveQuestions: "Have questions? Feel free to ask-I'm here to assist!",
  },
  tooltips: {
    freeFormQuestionText:
      "Assistant will help you troubleshoot messaging related issues including deliverability errors. Assistant can help you with data analysis and It can dive deeper into your messaging data in order to find a potential root cause. Assistant will also provide recommendations to solve the messaging errors and potential issues.",
    freeFormQuestionExamplesIntro:
      "Start with one of our guided flows or feel free to ask questions directly using the chat feature. Here are some examples of the potential questions that assistant can support:",
    freeFormQuestionExamples: [
      <>
        How many messages that I sent to Canada in the past 7 days have failed?
      </>,
      <>
        What are the messages which are failing because of the error code 30034?
      </>,
      <>How can I fix the error 30007?</>,
      <>Which phone number has maximum message failures?</>,
    ],
  },
};

export default copy;
